var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('button',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
    el: '.topbar',
    container: '.docs-container',
    duration: 300,
    easing: 'linear',
    force: true,
    cancelable: true,
    x: false,
    y: true
  }),expression:"{\n    el: '.topbar',\n    container: '.docs-container',\n    duration: 300,\n    easing: 'linear',\n    force: true,\n    cancelable: true,\n    x: false,\n    y: true\n  }"}],staticClass:"goTop",class:{ isVisible: _vm.isVisible },attrs:{"href":"#"}},[_c('i',{staticClass:"angle up icon"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }